import { Reducer } from "redux";

import { PatientHeaderDispatchTypes } from "../models/DispatchTypes/AllPatientRecord";
import { PatientHeaderResponse } from "../models/Api/AllPatientRecord";
import { PatientHeaderActionDispatchTypes } from "../constants/Patient";

const initialState: PatientHeaderResponse = {
  loading: false,
  response: {
    patientId: -1,
    patientName: "",
    memberInfo: {
      dateOfBirth: "",
      gender: "",
      subscriberId: "",
      medicareBeneficiaryIdentifier: "",
      phoneNo: "",
      healthPlan: "",
      effectiveDate: "",
      effectiveThrough: "",
      benefitPlan: "",
      product: "",
      insuranceState: "",
      languageName: "",
      extension: "",
      cellPhone: "",
      accommodationName: [],
      alternatePhone: "",
      contractIdPbp: "",
      groupPlanId: "",
      relationshipType: "",
      subscriberFirstName: "",
      subscriberLastName: "",
      subscriberDateOfBirth: "",
      subscriberGender: "",
      subscriberPrefix: "",
    },
    addressInfo: {
      residentialAddress: "",
      mailingAddress: "",
    },
    primaryPhysician: {
      physicianName: "",
      physicianNpiId: "",
      phoneExt: "",
      phoneNo: "",
      taxId: "",
      streetName1: "",
      streetName2: "",
      fax: "",
      county: "",
      city: "",
      physicianState: "",
      zipCode: "",
    },
  },
};

const PatientHeaderReducer: Reducer<
  PatientHeaderResponse,
  PatientHeaderDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case PatientHeaderActionDispatchTypes.GET_PATIENT_HEADER_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case PatientHeaderActionDispatchTypes.GET_PATIENT_HEADER_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case PatientHeaderActionDispatchTypes.GET_PATIENT_HEADER_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.response,
      };
    }
  }
  return state;
};

export default PatientHeaderReducer;
